import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Switch,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Button,
  Box,
} from "@chakra-ui/react";

const AccessibilityMenu = ({ fontSize, setFontSize }) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        className="accessibility-menu"
        borderRadius="full"
        size="lg"
        p={0}
        minW={12}
        h={12}
        iconSpacing={1}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "center",
          }}
        >
          <span style={{ margin: 0, fontSize: "18px" }}>A</span>
          <span style={{ margin: 0, fontSize: "24px" }}>A</span>
        </div>
      </MenuButton>
      <MenuList zIndex={10}>
        <Box minH="40px" paddingLeft="20px" paddingRight="20px" width="100%">
          <Slider
            defaultValue={fontSize}
            min={18}
            max={24}
            step={1}
            onChange={(val) => setFontSize(val)}
          >
            <SliderMark
              value={18}
              mt="2"
              ml="-1"
              fontSize="sm"
              lineHeight="18px"
            >
              A
            </SliderMark>
            <SliderMark
              value={24}
              mt="2"
              ml="-1"
              fontSize="lg"
              lineHeight="18px"
            >
              A
            </SliderMark>
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb boxSize={4} />
          </Slider>
        </Box>
      </MenuList>
    </Menu>
  );
};

export default AccessibilityMenu;
